export default {
  init(selector, config) {
    // JavaScript to be fired on the edit profile page

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    // Hide show facet clear button
    $(document).on('facetwp-loaded', function() {
      $.each(FWP.facets, function(key, val) {
        if( numProps(val) > 0 ){
          if( $('button#ResetFacets').is(":hidden")) {
            $('button#ResetFacets').show();
          }
          return false;
        }
        if( $('button#ResetFacets').is(":visible"))
        $('button#ResetFacets').hide();
      });

    });

    function numProps(obj) {
      var c = 0;
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) ++c;
      }
      return c;
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/search-results.js